class ProjectsAPI {

    static all (state) {

        let urls = []

        urls = this.urls(state)

        // fetch all urls and return promises
        return urls.map(option => {
            return fetch(option.url).then(response => {

                if (!response.ok) {
                    throw Error(
                        `Request rejected with status ${response.status}`)
                }

                return response.json().then(data => {
                    return data.map(project => {
                        project.source = option.name
                        return project
                    })
                })
            })
        })
    }

    static urls (state) {
        let options = this.options()
        let option = options.find(option => option.id === state.currentBranch)

        if (option) {
            options = [option]
        }

        return options
    }

    static options () {
        return [
            {
                id: 'bit',
                name: 'Barth Installatietechniek',
                url: 'https://barthinstallatietechniek.nl/wp-json/wp/v2/projects',
            },
            {
                id: 'ss',
                name: 'SolidSKID',
                url: 'https://solidskid.nl/wp-json/wp/v2/projects',
            },
            {
                id: 'cs',
                name: 'Controlscope',
                url: 'https://controlscope.nl/wp-json/wp/v2/projects',
            },
        ]
    }

}

export default ProjectsAPI

// WEBPACK FOOTER //
// ./src/js/projects/api/ProjectsAPI.js
